import { FileTypes } from '../../constants/file-type.constant';

const MAX_NAME_LENGTH = 254;
const MAX_JSON_VALIDATION_SIZE = 5 * 1024 * 1024; // 5 MB
const allowedTypes = Object.values(FileTypes) as string[];

export interface ErrorMessages {
  wrongFileSize: string;
  wrongFileNameLength: string;
  wrongTotalFileSize: string;
  wrongFileType: string;
}

export function isJsonFile(file: File): boolean {
  const fileName = file.name?.toLowerCase() ?? '';

  return file.type === FileTypes.Json || fileName.endsWith('.json');
}

export function isJsonContentValid(file: File): Promise<boolean> {
  if (!isJsonFile(file)) {
    return Promise.resolve(true);
  }

  if (file.size === 0) {
    return Promise.resolve(false);
  }

  if (file.size > MAX_JSON_VALIDATION_SIZE) {
    return Promise.resolve(true);
  }

  return file
    .text()
    .then((fileContent) => {
      const trimmedContent = fileContent.trim();

      if (!trimmedContent) {
        return false;
      }

      try {
        JSON.parse(trimmedContent);

        return true;
      } catch {
        return false;
      }
    })
    .catch(() => false);
}

export function validateFileNameSize(
  file: File,
  errorMessages: ErrorMessages,
  maxFileSize: number,
): string[] {
  const errors = [];

  if (file.size > maxFileSize) {
    errors.push(errorMessages.wrongFileSize);
  }

  if (file.name.length > MAX_NAME_LENGTH) {
    errors.push(errorMessages.wrongFileNameLength);
  }

  return errors;
}

export function validateFileHelper(
  file: File,
  errorMessages: ErrorMessages,
  maxFileSize: number,
): string[] {
  const errors = validateFileNameSize(file, errorMessages, maxFileSize);

  if (!isJsonFile(file) && !allowedTypes.includes(file.type)) {
    errors.push(errorMessages.wrongFileType);
  }

  return errors;
}
